import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import VMPaymentOptionsComponent from './component';


class VMPaymentOptionsContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      limit: 1000,
      offset: 0,
      vmPaymentMappingList: [],
      showVmPaymentMappingList: [],
      total: 0
    };
  }
  componentDidMount() {
    this.setState(prev => ({
      loading: true
    }));
    this.props.getDataFromAPI(
      `/vendingmachines/pg-mapping/all?limit=${this.state.limit}&offset=${this.state.offset}`,
      'GET',
      undefined,
      (response) => {          
        this.setState(prev => ({
          vmPaymentMappingList: response.list,
          showVmPaymentMappingList: response.list,
          total: response.total,
          loading: false
        }));
      },
      (err) => {
        toastr.error('ERROR', err.message);
        console.log(err);
        this.setState(prev => ({
          loading: false
        }));
      }
    );
  }
  onChangeSearchNameInput = (e,data) =>{
    const regex = new RegExp(data.value,'i');    
    const newList=this.state.vmPaymentMappingList.filter(vm => 
       vm.name.match(regex)
    );
    
    this.setState(prev => ({
        showVmPaymentMappingList: newList
    }))
  }
onChangeSearchIdInput = (e,data) => {
  const newList=this.state.vmPaymentMappingList.filter(vm => 
    vm.vm_id.toString().startsWith(data.value)
 );
    this.setState(prev => ({
        showVmPaymentMappingList: newList
    }))
}
  render() {
    return (
      <VMPaymentOptionsComponent
        loading={this.state.loading}
        total={this.state.total}
        showVmPaymentMappingList={this.state.showVmPaymentMappingList}
        onChangeSearchNameInput={this.onChangeSearchNameInput}
        onChangeSearchIdInput={this.onChangeSearchIdInput}
      />
    );
  }
}

export default withRouter(connect(null, { getDataFromAPI })(VMPaymentOptionsContainer));


// WEBPACK FOOTER //
// ./src/Modules/VMPaymentList/container.jsx